export const canShowEmbed = (index) => {
  // if (
  //   $($(".div-gpt-ad").get(index)).children("div").children("iframe").length > 0
  // )
  if (
    $($(".div-gpt-ad").get(index)).children("div").children("iframe").length
  ) {
    return false;
  }

  if ($(".sidebar .sidebar-widget").length && index === 0) {
    $(".sidebar .sidebar-widget").css("display", "block");
    return false;
  }
  return true;
};

export const getEmbed = (post = false) => {
  return new Promise((resolve, reject) => {
    $.ajax({
      type: "POST",
      dataType: "html",
      url: post ? show_post_social_embed.ajaxurl : show_social_embed.ajaxurl,
      data: {
        action: post ? "show_post_social_embed" : "show_social_embed",
        post_id: typeof post_id !== "undefined" ? post_id : 0,
        is_home: typeof is_home !== "undefined" ? is_home : false,
      },
      success: function (res) {
        let response = res;

        if (response.endsWith("0")) {
          response = response.substring(0, response.length - 1);
          if (response.replace(/\s/g, "").length > 0) {
          }
        }

        if (JSON.parse(response)) {
          response = JSON.parse(response);

          if (response.success) {
            return resolve(response);
          }
        }

        return resolve("success");
      },
    });
  });
};

export const raiseSocialEmbed = () => {
  if (!$("body").hasClass("sales")) {
    getEmbed()
      .then((res) => {
        if (res.success) {
          const widgetCount = $(".widget-alt").length;
          for (let i = 0; i < widgetCount; i++) {
            let isEven = i % 2 === 0;
            let embedContent = isEven ? res.first_embed : res.second_embed;

            if (
              canShowEmbed(isEven ? 0 : i) &&
              $($(".widget-alt").get(i)).length &&
              embedContent
            ) {
              embedContent = embedContent.replace(
                /<script[^>]*src="[^"]*instagram\.com\/embed\.js"[^>]*><\/script>/,
                ""
              );
              $($(".widget-alt").get(i)).html(embedContent);
              if (embedContent.includes("fb-post")) {
                FB.init({
                  xfbml: true,
                  version: "v19.0",
                });
              }
              lazyLoadImages();
              if (embedContent.includes("wp-twitter-embed")) {
                loadTwitterEmbed();
              }
              setTimeout(() => {
                $($(".widget-alt").get(i)).css("width", "auto");
              }, 4000);
            }
          }
        }
      })
      .catch((err) => console.log(err));
  }
};

export function initMobileSlider() {
  $(".slider-mobile").each(function () {
    var $this = $(this);
    var rtl = false;
    if ($(window).width() < 768 && !$this.hasClass("slick-initialized")) {
      if ($("html").attr("dir")) {
        if ($("html").attr("dir") == "rtl") {
          rtl = true;
        }
      }
      $this.slick({
        dots: true,
        rtl: rtl,
      });
    } else if ($(window).width() > 768 && $this.hasClass("slick-initialized")) {
      $this.slick("unslick");
    }
  });
}

export function editorsPickSliderInit() {
  $(".slider-desktop").each(function () {
    var $this = $(this);
    var rtl = false;
    if ($(".editors-pick-slider--container").attr("dir")) {
      if ($(".editors-pick-slider--container").attr("dir") == "rtl") {
        rtl = true;
      }
    }

    $this.slick({
      dots: true,
      rtl: rtl,
      slidesToShow: 3,
      slidesToScroll: 1,
      autoplay: true,
      autoplaySpeed: 2000,
      initialSlide: 1,
      responsive: [
        {
          breakpoint: 768,
          settings: {
            slidesToShow: 1,
            slidesToScroll: 1,
          },
        },
      ],
    });
  });
  $(".slider-desktop").show();

  $(".editors-pick-slider--container").css("min-height", "0");
}

export function lazyLoadImages() {
  var lazyLoadElements = document.querySelectorAll(
    ".lazy-load, .lazy-load-block, iframe[data-src]"
  );
  var observer;

  function handleIntersection(entries) {
    entries.forEach(function (entry) {
      if (entry.isIntersecting) {
        var element = entry.target;
        var dataUrl = element.getAttribute("data-src");

        if (element.classList.contains("lazy-load")) {
          // For background images
          element.style.backgroundImage = "url(" + dataUrl + ")";
        } else if (element.classList.contains("lazy-load-block")) {
          // For img elements
          element.setAttribute("src", dataUrl);
          element.style.display = "none";
          element.offsetHeight;
          element.style.display = "";
          element.style.margin = "2.7rem 0 0 -0.5rem";
        } else if (element.tagName === "IFRAME") {
          if (!dataUrl) {
            return;
          }
          // For iframe elements
          element.src = dataUrl;
          element.removeAttribute("data-src");
        }

        observer.unobserve(element);
      }
    });
  }

  function observeElements() {
    lazyLoadElements.forEach(function (element) {
      observer.observe(element);
    });
  }

  if ("IntersectionObserver" in window) {
    observer = new IntersectionObserver(handleIntersection);

    observeElements();

    // Reobserve elements on window resize with throttling
    function throttle(func, delay) {
      let timeout;
      return function () {
        const context = this;
        const args = arguments;
        clearTimeout(timeout);
        timeout = setTimeout(function () {
          func.apply(context, args);
        }, delay);
      };
    }

    // window.addEventListener('resize', throttle(function() {
    //   observer.disconnect();
    //   observeElements();
    // }, 200)); // Adjust the delay as needed
  }
}

export function showSuggestions() {
  let searchInput = $(".search__field");
  let suggestionsContainer = $("#suggestions-container");
  let feelingLuckyBtn = $("#lucky-btn");
  let clearSearchContainer = $(".clear_search_container");
  let divider = $(".divider");

  const suggestions = suggestionsContainer.data("suggestions");

  $(document).on("focus click input", ".search__field", function () {
    searchInput = $(this);
    const searchText = $(this).val().toLowerCase();
    suggestionsContainer = $(this)
      .closest(".search_container")
      .find(".suggestions");

    feelingLuckyBtn = $(this).closest(".search_container").find("#lucky-btn");
    feelingLuckyBtn.css("display", "none");

    clearSearchContainer = $(this)
      .closest(".search_container")
      .find(".clear_search_container");
    divider = $(this).closest(".search_container").find(".divider");

    if (searchText == "") {
      displaySuggestions(suggestions, suggestionsContainer);
    } else {
      clearSearchContainer.css("display", "flex");
      divider.css("display", "flex");
      const filteredSuggestions = suggestions.filter((suggestion) =>
        suggestion.toLowerCase().includes(searchText)
      );
      displaySuggestions(filteredSuggestions, suggestionsContainer);
    }
  });

  function displaySuggestions(filteredSuggestions, suggestionsContainer) {
    suggestionsContainer.html("");
    if (filteredSuggestions.length > 0) {
      const suggestionDivider = $("<hr/>").addClass("divider_suggestion");
      suggestionsContainer.append(suggestionDivider);
    }
    filteredSuggestions.forEach((suggestion) => {
      const suggestionElement = $("<div></div>")
        .addClass("suggestion")
        .text(suggestion);
      suggestionElement.on("click", function () {
        searchInput.val(suggestion);
        clearSearchContainer.css("display", "flex");
        divider.css("display", "flex");
        suggestionsContainer.html("");
        showSpinner();
        redirectToSearchResults(suggestion);
      });
      suggestionsContainer.append(suggestionElement);
    });
  }

  $(document).click(function (e) {
    if (!searchInput.is(e.target)) {
      suggestionsContainer.html("");
      if (searchInput.val() == "") {
        feelingLuckyBtn.css("display", "flex");
      }
    }
  });
}

export function clearInputSearch() {
  function toggleClearButton() {
    const clearSearchContainer = $(this)
      .closest(".search_container")
      .find(".clear_search_container");
    const divider = $(this).closest(".search_container").find(".divider");
    if ($(this).val().trim() === "") {
      clearSearchContainer.css("display", "none");
      divider.css("display", "none");
    } else {
      clearSearchContainer.css("display", "flex");
      divider.css("display", "flex");
    }
  }

  $(document).on("input", ".search__field", toggleClearButton);
  $(document).ready(function () {
    toggleClearButton.call($(".search__field"));
  });

  $(document).on("click", ".clear_search_container", function () {
    const searchInput = $(this)
      .closest(".search_container")
      .find(".search__field");
    const divider = $(this).closest(".search_container").find(".divider");
    searchInput.val("");
    $(this).css("display", "none");
    divider.css("display", "none");
  });
}

export function redirectToSearchResults(value) {
  const query = value;
  const currentLang = $("body").data("lang");
  window.location.replace(
    window.location.origin +
      "/" +
      currentLang +
      "/smart-search/" +
      encodeURIComponent(query)
  );

  $.ajax({
    type: "POST",
    dataType: "json",
    url: search_spinner.ajaxurl,
    data: { action: "search_spinner", term: query },
    complete: function () {
      hideSpinner();
    },
  });
}

export function showSpinner() {
  $(".search-spinner").css("display", "inline-block");
}

export function hideSpinner() {
  $(".search-spinner").css("display", "none");
}

export function setWidthOfBar(className, widthClassName) {
  const widthComponent = $(`.${widthClassName}`).width();
  const innerBar = $(`.${className}`);
  innerBar.css("width", widthComponent + "px");
}

export function lozadLoad() {
  if (typeof lozad === "function") {
    const observer = lozad(".lozad", {
      load: (el) => {
        const bq = document.createElement("blockquote");
        bq.className = "twitter-tweet";

        const p = document.createElement("p");
        bq.appendChild(p);

        const twitterSrc = el.dataset.twitterSrc;
        const a = document.createElement("a");
        a.href = twitterSrc;
        bq.appendChild(a);

        const script = document.createElement("script");
        script.src = "https://platform.twitter.com/widgets.js";
        script.charset = "utf-8";
        script.async = true;

        el.insertAdjacentElement("beforeEnd", bq);
        el.insertAdjacentElement("beforeEnd", script);
      },
    });
    observer.observe();
  }
}

function loadTwitterEmbed() {
  let twitterEmbed = document.querySelector(".wp-twitter-embed");
  const bq = document.createElement("blockquote");
  bq.className = "twitter-tweet";

  const p = document.createElement("p");
  bq.appendChild(p);

  const twitterSrc = twitterEmbed.dataset.twitterSrc;
  const a = document.createElement("a");
  a.href = twitterSrc;
  bq.appendChild(a);

  const script = document.createElement("script");
  script.src = "https://platform.twitter.com/widgets.js";
  script.charset = "utf-8";
  script.async = true;

  twitterEmbed.insertAdjacentElement("beforeEnd", bq);
  twitterEmbed.insertAdjacentElement("beforeEnd", script);
}
